"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getAddObjectsFunctions;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));
var _construct2 = _interopRequireDefault(require("@babel/runtime/helpers/construct"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _color = _interopRequireDefault(require("color"));
var TWEEN = _interopRequireWildcard(require("@tweenjs/tween.js"));
function getAddObjectsFunctions() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var THREE = p.THREE,
    defaultMaterialProps = p.defaultMaterialProps,
    setOpacity = p.setOpacity,
    getThreeJsInternalRandomFunctions = p.getThreeJsInternalRandomFunctions;
  var _getThreeJsInternalRa = getThreeJsInternalRandomFunctions(),
    shuffleArray = _getThreeJsInternalRa.shuffleArray,
    getRandomInt = _getThreeJsInternalRa.getRandomInt,
    setRandomVariables = _getThreeJsInternalRa.setRandomVariables;
  function getMoveAxis(child) {
    if (!child.children[0].boundingBox) {
      child.children[0].boundingBox = new THREE.Box3().setFromObject(child.children[0]);
    }
    var size = new THREE.Vector3();
    child.children[0].boundingBox.getSize(size);
    return Object.keys(size).reduce(function (a, k) {
      a.push({
        axis: k,
        value: size[k]
      });
      return a;
    }, []).sort(function (a, b) {
      return a.value > b.value ? 1 : a.value < b.value ? -1 : 0;
    })[1].axis;
  }
  function scaleValue(value, from, to) {
    var width = from[1] - from[0];
    var state = to ? width > 0 ? value - from[0] : from[0] - value : Math.abs(width) * Math.abs(value);
    if (width === 0) {
      return to ? to[0] : from[0];
    }
    if (state <= 0) {
      return to ? to[0] : from[0];
    }
    if (state >= Math.abs(width)) {
      return to ? to[1] : from[1];
    }
    return to ? scaleValue(state / Math.abs(width), to) : width > 0 ? from[0] + state : from[0] - state;
  }
  function addMaterialToChildren(mesh) {
    var materialParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var shadow = arguments.length > 2 ? arguments[2] : undefined;
    if (!mesh.ready) {
      mesh.ready = true;
      mesh.traverse(function (child) {
        if (child.type === "Group") {
          addMaterialToChildren(child, materialParameters, shadow);
        } else {
          if (shadow !== null && shadow !== void 0 && shadow.enable) {
            if (materialParameters.opacity > 0) {
              child.castShadow = !shadow.disableCastShadow;
            }
            child.receiveShadow = !shadow.disableReceiveShadow;
          }
          if (!child.material || shadow !== null && shadow !== void 0 && shadow.enable && child.material && child.material.constructor === THREE.MeshBasicMaterial || shadow !== null && shadow !== void 0 && shadow.enable && child.material && child.material.constructor === THREE.MeshPhongMaterial) {
            child.material = new THREE.MeshStandardMaterial((0, _objectSpread2["default"])({
              roughness: 0.7,
              metalness: 0.75,
              emissiveIntensity: 0
            }, materialParameters));
          }
        }
      });
    }
  }
  function addToLayers(object) {
    var _cameraPropsFromObjec, _cameraPropsFromObjec2, _cameraPropsFromObjec3, _cameraPropsFromObjec4;
    var p = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var fullDataObject = arguments.length > 2 ? arguments[2] : undefined;
    var cameraPropsFromObject = (fullDataObject === null || fullDataObject === void 0 ? void 0 : fullDataObject.camera) || {};
    var hidden1 = (_cameraPropsFromObjec = cameraPropsFromObject["0"]) === null || _cameraPropsFromObjec === void 0 ? void 0 : _cameraPropsFromObjec.hidden;
    var hidden2 = (_cameraPropsFromObjec2 = cameraPropsFromObject["2"]) === null || _cameraPropsFromObjec2 === void 0 ? void 0 : _cameraPropsFromObjec2.hidden;
    var hidden3 = (_cameraPropsFromObjec3 = cameraPropsFromObject["3"]) === null || _cameraPropsFromObjec3 === void 0 ? void 0 : _cameraPropsFromObjec3.hidden;
    var hidden4 = (_cameraPropsFromObjec4 = cameraPropsFromObject["4"]) === null || _cameraPropsFromObjec4 === void 0 ? void 0 : _cameraPropsFromObjec4.hidden;
    if (!hidden1) {
      object.layers.enable(1 * 6 + p);
    }
    if (!hidden2) {
      object.layers.enable(2 * 6 + p);
    }
    if (!hidden3) {
      object.layers.enable(3 * 6 + p);
    }
    if (!hidden4) {
      object.layers.enable(4 * 6 + p);
    }
    object.traverse(function (child) {
      if (!hidden1) {
        child.layers.enable(1 * 6 + p);
      }
      if (!hidden2) {
        child.layers.enable(2 * 6 + p);
      }
      if (!hidden3) {
        child.layers.enable(3 * 6 + p);
      }
      if (!hidden4) {
        child.layers.enable(4 * 6 + p);
      }
    });
  }
  function loadObj(_ref) {
    var threeJs = _ref.threeJs,
      obj = _ref.obj,
      _ref$refreshObj = _ref.refreshObj,
      refreshObj = _ref$refreshObj === void 0 ? function () {} : _ref$refreshObj;
    var OBJLoader = threeJs.packages.OBJLoader;
    if (!threeJs.obj) {
      threeJs.obj = {};
    }
    if (threeJs.obj[obj]) {
      if (threeJs.obj[obj].ready) {
        refreshObj();
      } else {
        threeJs.obj[obj].listeners.push(refreshObj);
      }
    } else {
      threeJs.obj[obj] = {
        loader: new OBJLoader(),
        listeners: [refreshObj]
      };
      threeJs.obj[obj].loader.load(obj, function (response) {
        threeJs.obj[obj].object = response;
        threeJs.obj[obj].ready = true;
        var listeners = (0, _toConsumableArray2["default"])(threeJs.obj[obj].listeners);
        listeners.forEach(function (listener) {
          listener();
        });
      }, function (xhr) {}, function (error) {
        threeJs.obj[obj].loader.load("." + obj, function (response) {
          threeJs.obj[obj].object = response;
          threeJs.obj[obj].ready = true;
          var listeners = (0, _toConsumableArray2["default"])(threeJs.obj[obj].listeners);
          listeners.forEach(function (listener) {
            listener();
          });
        }, function (xhr) {}, function (error) {
          console.log(error);
        });
        console.log(error);
      });
    }
  }
  function preloader(_x, _x2) {
    return _preloader.apply(this, arguments);
  }
  function _preloader() {
    _preloader = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee14(threeJs, compositions) {
      var FontLoader;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            FontLoader = threeJs.packages.FontLoader;
            if (!threeJs.fonts) {
              threeJs.fonts = [];
            }
            if (!threeJs.obj) {
              threeJs.obj = {};
            }
            compositions.forEach(function (currentComposition) {
              var data = currentComposition.data;
              data.forEach(function (d) {
                var _d$calloutNotation, _d$calloutNotation2;
                if ((d === null || d === void 0 ? void 0 : d.geometryType) === "text" && d.geometryProps && d.geometryProps[0]) {
                  var _d$geometryProps = (0, _slicedToArray2["default"])(d.geometryProps, 1),
                    fontRef = _d$geometryProps[0];
                  threeJs.fonts[fontRef] = {
                    loader: new FontLoader(),
                    listeners: []
                  };
                  threeJs.fonts[fontRef].loader.load(fontRef, function (response) {
                    threeJs.fonts[fontRef].font = response;
                    threeJs.fonts[fontRef].ready = true;
                  }, function (xhr) {}, function () {
                    threeJs.fonts[fontRef].loader.load("." + fontRef, function (response) {
                      threeJs.fonts[fontRef].font = response;
                      threeJs.fonts[fontRef].ready = true;
                    });
                  });
                }
                if (d !== null && d !== void 0 && (_d$calloutNotation = d.calloutNotation) !== null && _d$calloutNotation !== void 0 && _d$calloutNotation.text && d !== null && d !== void 0 && (_d$calloutNotation2 = d.calloutNotation) !== null && _d$calloutNotation2 !== void 0 && _d$calloutNotation2.font) {
                  if (!threeJs.fonts[d.calloutNotation.font]) {
                    threeJs.fonts[d.calloutNotation.font] = {
                      loader: new FontLoader(),
                      listeners: []
                    };
                    threeJs.fonts[d.calloutNotation.font].loader.load(d.calloutNotation.font, function (response) {
                      threeJs.fonts[d.calloutNotation.font].font = response;
                      threeJs.fonts[d.calloutNotation.font].ready = true;
                    }, function (xhr) {}, function () {
                      threeJs.fonts[d.calloutNotation.font].loader.load("." + d.calloutNotation.font, function (response) {
                        threeJs.fonts[d.calloutNotation.font].font = response;
                        threeJs.fonts[d.calloutNotation.font].ready = true;
                      });
                    });
                  }
                }
                if (d.geometryType === "obj") {
                  var obj = d.geometryProps && d.geometryProps[0];
                  if (!threeJs.obj[obj]) {
                    loadObj({
                      threeJs: threeJs,
                      obj: obj
                    });
                  }
                }
              });
            });
            _context14.next = 6;
            return new Promise(function (resolve) {
              var sI = typeof window !== "undefined" && window.timeWeb ? window.timeWeb.o.setInterval : setInterval;
              var cI = typeof window !== "undefined" && window.timeWeb ? window.timeWeb.o.clearInterval : clearInterval;
              var _int6 = sI(function () {
                var foundProcessingFont = Object.keys(threeJs.fonts).find(function (font) {
                  return threeJs.fonts[font] && !threeJs.fonts[font].ready;
                });
                var foundProcessingObj = Object.keys(threeJs.obj).find(function (obj) {
                  return threeJs.obj[obj] && !threeJs.obj[obj].ready;
                });
                if (!foundProcessingFont && !foundProcessingObj) {
                  cI(_int6);
                  resolve();
                }
              }, 1);
            });
          case 6:
          case "end":
            return _context14.stop();
        }
      }, _callee14);
    }));
    return _preloader.apply(this, arguments);
  }
  function getMeshAndLinesForSvg(_ref2) {
    var threeJs = _ref2.threeJs,
      lineProps = _ref2.lineProps,
      lineOpacity = _ref2.lineOpacity,
      materialParameters = _ref2.materialParameters,
      w = _ref2.w,
      h = _ref2.h,
      d = _ref2.d,
      geometryType = _ref2.geometryType,
      geometryProps = _ref2.geometryProps,
      shadow = _ref2.shadow,
      fullDataObject = _ref2.fullDataObject,
      parentContainer = _ref2.parentContainer;
    var mesh = new THREE.Group();
    var linewidth = typeof (lineProps === null || lineProps === void 0 ? void 0 : lineProps.linewidth) === "number" ? lineProps === null || lineProps === void 0 ? void 0 : lineProps.linewidth : threeJs.lineProps.linewidth;
    var lineMaterial = new THREE.LineBasicMaterial({
      color: (lineProps === null || lineProps === void 0 ? void 0 : lineProps.color) || threeJs.lineProps.color,
      linewidth: parentContainer.offsetHeight / 570 * (threeJs.camera.zoom || 1) * linewidth,
      transparent: true,
      opacity: lineOpacity
    });
    lineMaterial.resize = function () {
      var linewidth = typeof (lineProps === null || lineProps === void 0 ? void 0 : lineProps.linewidth) === "number" ? lineProps.linewidth : threeJs.lineProps.linewidth;
      lineMaterial.linewidth = parentContainer.offsetHeight / 570 * (threeJs.camera.zoom || 1) * linewidth;
    };
    var meshMaterial = new THREE.MeshStandardMaterial((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, materialParameters), {}, {
      transparent: true
    }));
    var top = new THREE.Group();
    var front = new THREE.Group();
    var left = new THREE.Group();
    var right = new THREE.Group();
    var bottom = new THREE.Group();
    var back = new THREE.Group();
    mesh.add(top);
    mesh.add(front);
    mesh.add(left);
    mesh.add(right);
    mesh.add(bottom);
    mesh.add(back);
    var addDimension = 0.0001;
    var aW = w + addDimension;
    var aH = h + addDimension;
    var aD = d + addDimension;
    var geometry = geometryType === "sphere" ? (0, _construct2["default"])(THREE.SphereGeometry, [h / 2].concat((0, _toConsumableArray2["default"])(geometryProps))) : geometryType === "cone" ? (0, _construct2["default"])(THREE.ConeGeometry, [Math.min(d / 2, w / 2), h].concat((0, _toConsumableArray2["default"])(geometryProps))) : new THREE.PlaneGeometry(w, d);
    if (geometryType === "cone") {
      if (d > w) {
        geometry.scale(1, 1, d / w);
      } else if (w > d) {
        geometry.scale(w / d, 1, 1);
      }
    }
    var topPlane = geometryType === "obj" ? new THREE.Group() : new THREE.Mesh(geometry, meshMaterial);
    if (geometryType === "obj") {
      var refreshObj = function refreshObj() {
        var object = threeJs.obj[obj].object.clone();
        var bounding = new THREE.Box3().setFromObject(object);
        var width = bounding.max.x - bounding.min.x;
        var height = bounding.max.y - bounding.min.y;
        var depth = bounding.max.z - bounding.min.z;
        var scale = Math.min(w / width, h / height, d / depth);
        object.scale.x = scale;
        object.scale.y = scale;
        object.scale.z = scale;
        if (shadow.enable) {
          object.castShadow = !shadow.disableCastShadow;
          object.receiveShadow = !shadow.disableReceiveShadow;
        }
        topPlane.add(object);
        addToLayers(mesh, 0, fullDataObject);
        addMaterialToChildren(object, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, materialParameters), {}, {
          transparent: true
        }), shadow);
      };
      var obj = geometryProps[0];
      loadObj({
        threeJs: threeJs,
        obj: obj,
        refreshObj: refreshObj
      });
    }
    if (geometryType !== "sphere" && geometryType !== "obj") {
      topPlane.position.set(0, h / 2, 0);
      topPlane.rotation.set(-Math.PI / 2, 0, 0);
    }
    top.add(topPlane);
    var edgesTop = new THREE.BufferGeometry();
    edgesTop.setAttribute("position", new THREE.BufferAttribute(new Float32Array([-aW / 2, aH / 2, aD / 2, -aW / 2, aH / 2, -aD / 2].concat([-aW / 2, aH / 2, -aD / 2, aW / 2, aH / 2, -aD / 2], [aW / 2, aH / 2, -aD / 2, aW / 2, aH / 2, aD / 2], [aW / 2, aH / 2, aD / 2, -aW / 2, aH / 2, aD / 2])), 3));
    top.add(lineProps !== null && lineProps !== void 0 && lineProps.disable || threeJs.lineProps.disable ? new THREE.Object3D() : new THREE.LineSegments(edgesTop, lineMaterial));
    var frontPlane = geometryType === "sphere" || geometryType === "obj" ? new THREE.Object3D() : new THREE.Mesh(new THREE.PlaneGeometry(w, h), meshMaterial);
    frontPlane.position.set(0, 0, aD / 2);
    front.add(frontPlane);
    var edgesFront = new THREE.BufferGeometry();
    edgesFront.setAttribute("position", new THREE.BufferAttribute(new Float32Array([aW / 2, -aH / 2, aD / 2, -aW / 2, -aH / 2, aD / 2].concat([-aW / 2, -aH / 2, aD / 2, -aW / 2, aH / 2, aD / 2], [aW / 2, aH / 2, aD / 2, -aW / 2, aH / 2, aD / 2], [aW / 2, aH / 2, aD / 2, aW / 2, -aH / 2, aD / 2])), 3));
    front.add(lineProps !== null && lineProps !== void 0 && lineProps.disable || threeJs.lineProps.disable ? new THREE.Object3D() : new THREE.LineSegments(edgesFront, lineMaterial));
    var leftPlane = geometryType === "sphere" || geometryType === "obj" ? new THREE.Object3D() : new THREE.Mesh(new THREE.PlaneGeometry(d, h), meshMaterial);
    leftPlane.position.set(-aW / 2, 0, 0);
    leftPlane.rotation.set(0, -Math.PI / 2, 0);
    left.add(leftPlane);
    var edgesLeft = new THREE.BufferGeometry();
    edgesLeft.setAttribute("position", new THREE.BufferAttribute(new Float32Array([aW / 2, -aH / 2, aD / 2, aW / 2, -aH / 2, -aD / 2].concat([aW / 2, -aH / 2, -aD / 2, aW / 2, aH / 2, -aD / 2], [aW / 2, aH / 2, aD / 2, aW / 2, -aH / 2, aD / 2], [aW / 2, aH / 2, -aD / 2, aW / 2, aH / 2, aD / 2])), 3));
    left.add(lineProps !== null && lineProps !== void 0 && lineProps.disable || threeJs.lineProps.disable ? new THREE.Object3D() : new THREE.LineSegments(edgesLeft, lineMaterial));
    var rightPlane = geometryType === "sphere" || geometryType === "obj" ? new THREE.Object3D() : new THREE.Mesh(new THREE.PlaneGeometry(d, h), meshMaterial);
    rightPlane.position.set(aW / 2, 0, 0);
    rightPlane.rotation.set(0, Math.PI / 2, 0);
    right.add(rightPlane);
    var edgesRight = new THREE.BufferGeometry();
    edgesRight.setAttribute("position", new THREE.BufferAttribute(new Float32Array([-aW / 2, aH / 2, aD / 2, -aW / 2, aH / 2, -aD / 2].concat([-aW / 2, -aH / 2, aD / 2, -aW / 2, aH / 2, aD / 2], [-aW / 2, aH / 2, -aD / 2, -aW / 2, -aH / 2, -aD / 2], [-aW / 2, -aH / 2, -aD / 2, -aW / 2, -aH / 2, aD / 2])), 3));
    right.add(lineProps !== null && lineProps !== void 0 && lineProps.disable || threeJs.lineProps.disable ? new THREE.Object3D() : new THREE.LineSegments(edgesRight, lineMaterial));
    var bottomPlane = geometryType === "sphere" || geometryType === "obj" ? new THREE.Object3D() : new THREE.Mesh(new THREE.PlaneGeometry(w, d), meshMaterial);
    bottomPlane.position.set(0, -aH / 2, 0);
    bottomPlane.rotation.set(Math.PI / 2, 0, 0);
    bottom.add(bottomPlane);
    var edgesBottom = new THREE.BufferGeometry();
    edgesBottom.setAttribute("position", new THREE.BufferAttribute(new Float32Array([aW / 2, -aH / 2, aD / 2, -aW / 2, -aH / 2, aD / 2].concat([-aW / 2, -aH / 2, -aD / 2, -aW / 2, -aH / 2, aD / 2], [aW / 2, -aH / 2, aD / 2, aW / 2, -aH / 2, -aD / 2], [aW / 2, -aH / 2, -aD / 2, -aW / 2, -aH / 2, -aD / 2])), 3));
    bottom.add(lineProps !== null && lineProps !== void 0 && lineProps.disable || threeJs.lineProps.disable ? new THREE.Object3D() : new THREE.LineSegments(edgesBottom, lineMaterial));
    var backPlane = geometryType === "sphere" || geometryType === "obj" ? new THREE.Object3D() : new THREE.Mesh(new THREE.PlaneGeometry(w, h), meshMaterial);
    backPlane.position.set(0, 0, -aD / 2);
    backPlane.rotation.set(0, Math.PI, 0);
    back.add(backPlane);
    var edgesBack = new THREE.BufferGeometry();
    edgesBack.setAttribute("position", new THREE.BufferAttribute(new Float32Array([-aW / 2, aH / 2, -aD / 2, aW / 2, aH / 2, -aD / 2].concat([-aW / 2, aH / 2, -aD / 2, -aW / 2, -aH / 2, -aD / 2], [aW / 2, -aH / 2, -aD / 2, aW / 2, aH / 2, -aD / 2], [aW / 2, -aH / 2, -aD / 2, -aW / 2, -aH / 2, -aD / 2])), 3));
    back.add(lineProps !== null && lineProps !== void 0 && lineProps.disable || threeJs.lineProps.disable ? new THREE.Object3D() : new THREE.LineSegments(edgesBack, lineMaterial));
    var meshLines = new THREE.Object3D();
    if (geometryType !== "obj") {
      if (shadow.enable) {
        mesh.castShadow = !shadow.disableCastShadow;
        mesh.receiveShadow = !shadow.disableReceiveShadow;
      }
      addToLayers(mesh, 0, fullDataObject);
      addMaterialToChildren(mesh, materialParameters, shadow);
    }
    return {
      mesh: mesh,
      meshLines: meshLines
    };
  }
  function getMeshLinesForWebGL(_ref3) {
    var threeJs = _ref3.threeJs,
      lineProps = _ref3.lineProps,
      lineOpacity = _ref3.lineOpacity,
      materialParameters = _ref3.materialParameters,
      w = _ref3.w,
      h = _ref3.h,
      d = _ref3.d,
      geometryType = _ref3.geometryType,
      geometry = _ref3.geometry;
    var _threeJs$packages = threeJs.packages,
      LineMaterial = _threeJs$packages.LineMaterial,
      Line2 = _threeJs$packages.Line2,
      LineSegmentsGeometry = _threeJs$packages.LineSegmentsGeometry;
    if (lineProps !== null && lineProps !== void 0 && lineProps.disable || threeJs.lineProps.disable) {
      return new THREE.Object3D();
    }
    var edges = geometry ? new THREE.EdgesGeometry(geometry) : geometryType === "sphere" ? new THREE.EdgesGeometry(new THREE.BoxGeometry(w, h, d)) : new THREE.EdgesGeometry(new THREE.BoxGeometry(w, h, d));
    var meshLinesGeometry = new LineSegmentsGeometry().fromEdgesGeometry(edges);
    var lineColor = (lineProps === null || lineProps === void 0 ? void 0 : lineProps.color) || threeJs.lineProps.color;
    var lColor = (0, _color["default"])(lineColor);
    if (lineOpacity >= 0 && lineOpacity < 1) {
      lColor = lColor.mix((0, _color["default"])(materialParameters.color), Math.max(0, 1 - lineOpacity * 1.2));
    }
    var meshLinesMaterial = new LineMaterial({
      color: lColor.hex(),
      linewidth: typeof (lineProps === null || lineProps === void 0 ? void 0 : lineProps.linewidth) === "number" ? 0.0015 * lineProps.linewidth : 0.0015 * threeJs.lineProps.linewidth,
      transparent: false
    });
    var meshLines = new Line2(meshLinesGeometry, meshLinesMaterial);
    meshLines.computeLineDistances();
    meshLines.scale.set(1, 1, 1);
    if (lineProps !== null && lineProps !== void 0 && lineProps.disable || threeJs.lineProps.disable) {
      meshLines = new THREE.Object3D();
    }
    return meshLines;
  }
  function getMeshAndLinesForWebGL(_ref4) {
    var threeJs = _ref4.threeJs,
      lineProps = _ref4.lineProps,
      lineOpacity = _ref4.lineOpacity,
      materialParameters = _ref4.materialParameters,
      w = _ref4.w,
      h = _ref4.h,
      d = _ref4.d,
      geometryType = _ref4.geometryType,
      geometryProps = _ref4.geometryProps,
      shadow = _ref4.shadow,
      fullDataObject = _ref4.fullDataObject;
    var _threeJs$packages2 = threeJs.packages,
      FontLoader = _threeJs$packages2.FontLoader,
      TextGeometry = _threeJs$packages2.TextGeometry;
    var isShadow = materialParameters.opacity === 0 && shadow.enable;
    var mesh;
    var meshMaterial = geometryType !== "obj" ? isShadow ? new THREE.ShadowMaterial() : new THREE.MeshBasicMaterial((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, materialParameters), {}, {
      transparent: true
    })) : null;
    if (meshMaterial) {
      meshMaterial.needsUpdate = true;
      if (isShadow) {
        meshMaterial.opacity = typeof shadow.opacity === "number" ? shadow.opacity : 0.5;
        meshMaterial.alphaToCoverage = true;
      }
    }
    var geometry;
    var geometryHasHole;
    if (geometryType === "obj") {
      mesh = new THREE.Object3D();
      var obj = geometryProps[0];
      var refreshObj = function refreshObj() {
        var object = threeJs.obj[obj].object.clone();
        var bounding = new THREE.Box3().setFromObject(object);
        var width = bounding.max.x - bounding.min.x;
        var height = bounding.max.y - bounding.min.y;
        var depth = bounding.max.z - bounding.min.z;
        var scale = Math.min(w / width, h / height, d / depth);
        object.scale.x = scale;
        object.scale.y = scale;
        object.scale.z = scale;
        if (shadow.enable) {
          mesh.castShadow = !shadow.disableCastShadow;
          mesh.receiveShadow = !shadow.disableReceiveShadow;
        }
        mesh.add(object);
        addToLayers(mesh, 0, fullDataObject);
        addMaterialToChildren(mesh, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, materialParameters), {}, {
          transparent: true
        }), shadow);
      };
      loadObj({
        threeJs: threeJs,
        obj: obj,
        refreshObj: refreshObj
      });
    } else if (geometryType === "extrude") {
      var shape = new THREE.Shape();
      if (Array.isArray(geometryProps[0])) {
        geometryProps[0].forEach(function (_ref5) {
          var func = _ref5.func,
            props = _ref5.props;
          if (shape[func]) {
            var _props = (0, _toArray2["default"])(props),
              x = _props[0],
              y = _props[1],
              rest = _props.slice(2);
            x = x - w / 2;
            y = -(y - h / 2);
            shape[func].apply(shape, [x, y].concat((0, _toConsumableArray2["default"])(rest)));
          }
        });
      }
      var path;
      if (Array.isArray(geometryProps[1])) {
        path = new THREE.Path();
        geometryProps[1].forEach(function (_ref6) {
          var func = _ref6.func,
            props = _ref6.props;
          if (path[func]) {
            var _path;
            var _props2 = (0, _toArray2["default"])(props),
              x = _props2[0],
              y = _props2[1],
              rest = _props2.slice(2);
            x = x - w / 2;
            y = -(y - h / 2);
            (_path = path)[func].apply(_path, [x, y].concat((0, _toConsumableArray2["default"])(rest)));
          }
        });
        geometryHasHole = true;
      }
      if (path) {
        shape.holes = [path];
      }
      var extrudeSettings = {
        depth: 1,
        bevelEnabled: false
      };
      geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
      var extrudeMesh = new THREE.Mesh(geometry, meshMaterial);
      extrudeMesh.scale.set(1, 1, d);
      extrudeMesh.position.z = -d / 2;
      extrudeMesh.updateMatrix();
      geometry.applyMatrix4(extrudeMesh.matrix);
      extrudeMesh.scale.set(1, 1, d);
      mesh = new THREE.Mesh(geometry, meshMaterial);
    } else if (geometryType === "text") {
      mesh = new THREE.Object3D();
      var _geometryProps = (0, _slicedToArray2["default"])(geometryProps, 4),
        fontRef = _geometryProps[0],
        text = _geometryProps[1],
        _geometryProps$ = _geometryProps[2],
        boundingX = _geometryProps$ === void 0 ? "center" : _geometryProps$,
        _geometryProps$2 = _geometryProps[3],
        shiftRatioHeight = _geometryProps$2 === void 0 ? [0, 0] : _geometryProps$2;
      if (fontRef) {
        var refreshText = function refreshText() {
          var font = threeJs.fonts[fontRef].font;
          var geometry = new TextGeometry(text, {
            font: font,
            size: h,
            height: d
          });
          geometry.computeBoundingBox();
          var textWidth = geometry.boundingBox.max.x - geometry.boundingBox.min.x;
          var scale = textWidth > w ? w / textWidth : 1;
          geometry.scale(scale, scale, 1);
          geometry.computeBoundingBox();
          var bounding = {
            center: -0.5 * (geometry.boundingBox.max.x - geometry.boundingBox.min.x),
            left: 0,
            right: -(geometry.boundingBox.max.x - geometry.boundingBox.min.x)
          };
          geometry.translate(shiftRatioHeight[0] * h + bounding[boundingX], shiftRatioHeight[1] * h + -0.5 * (geometry.boundingBox.max.y - geometry.boundingBox.min.y), -0.5 * (geometry.boundingBox.max.z - geometry.boundingBox.min.z));
          textMesh = new THREE.Mesh(geometry, meshMaterial);
          mesh.add(textMesh);
        };
        var textMesh;
        if (threeJs.fonts && threeJs.fonts[fontRef]) {
          if (threeJs.fonts[fontRef].ready) {
            refreshText();
          } else {
            threeJs.fonts[fontRef].listeners.push(refreshText);
          }
        } else {
          threeJs.fonts[fontRef] = {
            loader: new FontLoader(),
            listeners: [refreshText]
          };
          threeJs.fonts[fontRef].loader.load(fontRef, function (response) {
            threeJs.fonts[fontRef].font = response;
            threeJs.fonts[fontRef].ready = true;
            var listeners = (0, _toConsumableArray2["default"])(threeJs.fonts[fontRef].listeners);
            listeners.forEach(function (listener) {
              listener();
            });
          });
        }
      }
    } else {
      geometry = geometryType === "sphere" ? (0, _construct2["default"])(THREE.SphereGeometry, [h / 2].concat((0, _toConsumableArray2["default"])(geometryProps))) : geometryType === "cone" ? (0, _construct2["default"])(THREE.ConeGeometry, [Math.min(d / 2, w / 2), h].concat((0, _toConsumableArray2["default"])(geometryProps))) : (0, _construct2["default"])(THREE.BoxGeometry, [w, h, d].concat((0, _toConsumableArray2["default"])(geometryProps)));
      if (geometryType === "cone") {
        if (d > w) {
          geometry.scale(1, 1, d / w);
        } else if (w > d) {
          geometry.scale(w / d, 1, 1);
        }
      }
      mesh = new THREE.Mesh(geometry, meshMaterial);
    }
    var meshLines = geometryType !== "obj" ? getMeshLinesForWebGL({
      threeJs: threeJs,
      lineProps: lineProps,
      lineOpacity: lineOpacity,
      materialParameters: materialParameters,
      w: w,
      h: h,
      d: d,
      geometryType: geometryType,
      geometry: !threeJs.editor && (geometryType === "extrude" || geometryType === "cone") ? geometry : null
    }) : new THREE.Object3D();
    if (shadow !== null && shadow !== void 0 && shadow.enable) {
      meshLines.castShadow = false;
      meshLines.receiveShadow = !shadow.disableReceiveShadow;
    }
    meshLines.traverse(function (child) {
      if (shadow !== null && shadow !== void 0 && shadow.enable) {
        child.castShadow = false;
        child.receiveShadow = !shadow.disableReceiveShadow;
      }
    });
    if (geometryType !== "obj") {
      if (shadow.enable) {
        if (!isShadow) {
          mesh.castShadow = !shadow.disableCastShadow;
        }
        mesh.receiveShadow = !shadow.disableReceiveShadow;
      }
      addToLayers(mesh, isShadow ? 3 : 0, fullDataObject);
      addMaterialToChildren(mesh, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, materialParameters), geometryType === "extrude" && geometryHasHole ? {
        side: THREE.DoubleSide
      } : {}), shadow);
    }
    return {
      mesh: mesh,
      meshLines: meshLines
    };
  }
  function getEditLines(_ref7) {
    var _threeJs$editLines, _fullDataObject$editL, _threeJs$editLines2, _fullDataObject$editL2;
    var threeJs = _ref7.threeJs,
      materialParameters = _ref7.materialParameters,
      w = _ref7.w,
      h = _ref7.h,
      d = _ref7.d,
      shadow = _ref7.shadow,
      fullDataObject = _ref7.fullDataObject,
      parentContainer = _ref7.parentContainer;
    var _threeJs$packages3 = threeJs.packages,
      LineMaterial = _threeJs$packages3.LineMaterial,
      Line2 = _threeJs$packages3.Line2,
      LineSegmentsGeometry = _threeJs$packages3.LineSegmentsGeometry;
    var editLines = new THREE.Object3D();
    var isShadow = materialParameters.opacity === 0 && shadow.enable;
    if (!isShadow && (_threeJs$editLines = threeJs.editLines) !== null && _threeJs$editLines !== void 0 && _threeJs$editLines.enable && !((_fullDataObject$editL = fullDataObject.editLines) !== null && _fullDataObject$editL !== void 0 && _fullDataObject$editL.disable) && threeJs.renderType !== "SVG" || materialParameters.opacity !== 0 && (_threeJs$editLines2 = threeJs.editLines) !== null && _threeJs$editLines2 !== void 0 && _threeJs$editLines2.enable && !((_fullDataObject$editL2 = fullDataObject.editLines) !== null && _fullDataObject$editL2 !== void 0 && _fullDataObject$editL2.disable) && threeJs.renderType === "SVG") {
      var _fullDataObject$editL3, _fullDataObject$editL4, _fullDataObject$editL5, _fullDataObject$editL6, _fullDataObject$editL7, _threeJs$editLinesDat, _threeJs$editLinesDat2, _threeJs$editLinesDat3, _threeJs$editLines3, _threeJs$editLines4, _threeJs$editLines5;
      var lineColor = ((_fullDataObject$editL3 = fullDataObject.editLines) === null || _fullDataObject$editL3 === void 0 ? void 0 : _fullDataObject$editL3.color) || threeJs.editLines.color || 0x000000;
      var meshLinesMaterial = new LineMaterial({
        color: lineColor,
        linewidth: typeof ((_fullDataObject$editL4 = fullDataObject.editLines) === null || _fullDataObject$editL4 === void 0 ? void 0 : _fullDataObject$editL4.linewidth) === "number" ? 0.001 * fullDataObject.editLines.linewidth : 0.001 * (threeJs.editLines.linewidth || 1),
        transparent: true,
        opacity: getRandomInt.apply(void 0, (0, _toConsumableArray2["default"])((_fullDataObject$editL5 = fullDataObject.editLines) !== null && _fullDataObject$editL5 !== void 0 && _fullDataObject$editL5.opacityRange && typeof ((_fullDataObject$editL6 = fullDataObject.editLines) === null || _fullDataObject$editL6 === void 0 ? void 0 : _fullDataObject$editL6.opacityRange[0]) === "number" && typeof ((_fullDataObject$editL7 = fullDataObject.editLines) === null || _fullDataObject$editL7 === void 0 ? void 0 : _fullDataObject$editL7.opacityRange[1]) === "number" ? fullDataObject.editLines.opacityRange : (_threeJs$editLinesDat = threeJs.editLinesData) !== null && _threeJs$editLinesDat !== void 0 && _threeJs$editLinesDat.opacityRange && typeof ((_threeJs$editLinesDat2 = threeJs.editLinesData) === null || _threeJs$editLinesDat2 === void 0 ? void 0 : _threeJs$editLinesDat2.opacityRange[0]) === "number" && typeof ((_threeJs$editLinesDat3 = threeJs.editLinesData) === null || _threeJs$editLinesDat3 === void 0 ? void 0 : _threeJs$editLinesDat3.opacityRange[1]) === "number" ? threeJs.editLinesData.opacityRange : (_threeJs$editLines3 = threeJs.editLines) !== null && _threeJs$editLines3 !== void 0 && _threeJs$editLines3.opacityRange && typeof ((_threeJs$editLines4 = threeJs.editLines) === null || _threeJs$editLines4 === void 0 ? void 0 : _threeJs$editLines4.opacityRange[0]) === "number" && typeof ((_threeJs$editLines5 = threeJs.editLines) === null || _threeJs$editLines5 === void 0 ? void 0 : _threeJs$editLines5.opacityRange[1]) === "number" ? threeJs.editLines.opacityRange : [5, 10])) / 100,
        depthWrite: false
      });
      var GetMesh = Line2;
      var getGeometry = function getGeometry(points) {
        var positions = new Float32Array(points.length * 3);
        points.forEach(function (point, i) {
          positions[3 * i] = point.x;
          positions[3 * i + 1] = point.y;
          positions[3 * i + 2] = point.z;
        });
        return new LineSegmentsGeometry().setPositions(positions);
      };
      if (threeJs.renderType === "SVG") {
        var _fullDataObject$editL8;
        var linewidth = typeof ((_fullDataObject$editL8 = fullDataObject.editLines) === null || _fullDataObject$editL8 === void 0 ? void 0 : _fullDataObject$editL8.linewidth) === "number" ? fullDataObject.editLines.linewidth : threeJs.editLines.linewidth || 1;
        meshLinesMaterial = new THREE.LineBasicMaterial({
          color: lineColor,
          linewidth: parentContainer.offsetHeight / 570 * (threeJs.camera.zoom || 1) * linewidth,
          transparent: false,
          opacity: getRandomInt(5, 10) / 100,
          alphaToCoverage: true
        });
        meshLinesMaterial.resize = function () {
          var _fullDataObject$editL9;
          var linewidth = typeof ((_fullDataObject$editL9 = fullDataObject.editLines) === null || _fullDataObject$editL9 === void 0 ? void 0 : _fullDataObject$editL9.linewidth) === "number" ? fullDataObject.editLines.linewidth : threeJs.editLines.linewidth || 1;
          meshLinesMaterial.linewidth = parentContainer.offsetHeight / 570 * (threeJs.camera.zoom || 1) * linewidth;
        };
        GetMesh = THREE.LineSegments;
        getGeometry = function getGeometry(points) {
          return new THREE.BufferGeometry().setFromPoints(points);
        };
      }
      var size = {
        x: w,
        y: h,
        z: d
      };
      var axis = Object.keys(size).reduce(function (a, k) {
        a.push({
          axis: k,
          value: size[k]
        });
        return a;
      }, []).sort(function (a, b) {
        return a.value > b.value ? 1 : a.value < b.value ? -1 : 0;
      })[2].axis;
      var overSizeDim = axis === "x" ? w : axis === "y" ? h : d;
      var overSize = getRandomInt(5, 10) / 10 * overSizeDim;
      var meshLine1 = new GetMesh(getGeometry([axis === "y" ? new THREE.Vector3(w / 2, -h / 2 - overSize / 2, d / 2) : new THREE.Vector3(w / 2, -h / 2, d / 2), axis === "x" ? new THREE.Vector3(-w / 2 - overSize, -h / 2, d / 2) : axis === "z" ? new THREE.Vector3(w / 2, -h / 2, -d / 2 - overSize) : new THREE.Vector3(w / 2, h / 2 + overSize / 2, d / 2)]), meshLinesMaterial);
      editLines.add(meshLine1);
      var meshLine2 = new GetMesh(getGeometry([axis === "y" ? new THREE.Vector3(-w / 2, -h / 2 - overSize / 2, d / 2) : new THREE.Vector3(-w / 2, -h / 2, d / 2), axis === "x" ? new THREE.Vector3(w / 2 + overSize, -h / 2, d / 2) : axis === "z" ? new THREE.Vector3(-w / 2, -h / 2, -d / 2 - overSize) : new THREE.Vector3(-w / 2, h / 2 + overSize / 2, d / 2)]), meshLinesMaterial);
      editLines.add(meshLine2);
      var meshLine3 = new GetMesh(getGeometry([axis === "y" ? new THREE.Vector3(w / 2, -h / 2 - overSize / 2, -d / 2) : new THREE.Vector3(w / 2, h / 2, d / 2), axis === "x" ? new THREE.Vector3(-w / 2 - overSize, h / 2, d / 2) : axis === "z" ? new THREE.Vector3(w / 2, h / 2, -d / 2 - overSize) : new THREE.Vector3(w / 2, h / 2 + overSize / 2, -d / 2)]), meshLinesMaterial);
      editLines.add(meshLine3);
      var meshLine4 = new GetMesh(getGeometry([axis === "y" ? new THREE.Vector3(-w / 2, -h / 2 - overSize / 2, -d / 2) : new THREE.Vector3(-w / 2, h / 2, d / 2), axis === "x" ? new THREE.Vector3(w / 2 + overSize, h / 2, d / 2) : axis === "z" ? new THREE.Vector3(-w / 2, h / 2, -d / 2 - overSize) : new THREE.Vector3(-w / 2, h / 2 + overSize / 2, -d / 2)]), meshLinesMaterial);
      editLines.add(meshLine4);
    }
    addToLayers(editLines, 1, fullDataObject);
    return editLines;
  }
  function getCalloutNotation(_ref8) {
    var _fullDataObject$callo2, _fullDataObject$callo3, _threeJs$calloutNotat;
    var threeJs = _ref8.threeJs,
      w = _ref8.w,
      fullDataObject = _ref8.fullDataObject,
      onRenderFunctions = _ref8.onRenderFunctions;
    var FontLoader = threeJs.packages.FontLoader;
    var cameraDataForCalloutNotation = (0, _objectSpread2["default"])({}, [0, 2, 3, 4].reduce(function (o, key) {
      var _fullDataObject$callo;
      o[key] = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, fullDataObject !== null && fullDataObject !== void 0 && fullDataObject.camera && fullDataObject.camera[key] ? fullDataObject.camera[key] : {}), fullDataObject !== null && fullDataObject !== void 0 && (_fullDataObject$callo = fullDataObject.calloutNotation) !== null && _fullDataObject$callo !== void 0 && _fullDataObject$callo.camera && fullDataObject.calloutNotation.camera[key] ? fullDataObject.calloutNotation.camera[key] : {});
      return o;
    }, {}));
    var calloutNotation = new THREE.Object3D();
    if (fullDataObject !== null && fullDataObject !== void 0 && (_fullDataObject$callo2 = fullDataObject.calloutNotation) !== null && _fullDataObject$callo2 !== void 0 && _fullDataObject$callo2.text && fullDataObject !== null && fullDataObject !== void 0 && (_fullDataObject$callo3 = fullDataObject.calloutNotation) !== null && _fullDataObject$callo3 !== void 0 && _fullDataObject$callo3.font && (_threeJs$calloutNotat = threeJs.calloutNotations) !== null && _threeJs$calloutNotat !== void 0 && _threeJs$calloutNotat.enable) {
      var _fullDataObject$callo4, _fullDataObject$callo5, _fullDataObject$callo6, _fullDataObject$callo7, _fullDataObject$callo8, _fullDataObject$callo9;
      var getCurves = function getCurves() {
        var _fullDataObject$callo10, _fullDataObject$callo11, _fullDataObject$callo12, _fullDataObject$callo13, _fullDataObject$callo14, _fullDataObject$callo15, _fullDataObject$callo16;
        var line = new THREE.LineCurve3(new THREE.Vector3(textMeshPosition.x, textMeshPosition.y, textMeshPosition.z), new THREE.Vector3(0, 0, 0));
        var startPoint = new THREE.Vector3();
        var endPoint = new THREE.Vector3();
        var isDimensionLine = (_fullDataObject$callo10 = fullDataObject.calloutNotation.lineProps) === null || _fullDataObject$callo10 === void 0 ? void 0 : _fullDataObject$callo10.isDimensionLine;
        var disableFrenet = isDimensionLine ? true : (_fullDataObject$callo11 = fullDataObject.calloutNotation.lineProps) === null || _fullDataObject$callo11 === void 0 ? void 0 : _fullDataObject$callo11.disableFrenet;
        var forceArrowBase = isDimensionLine ? true : (_fullDataObject$callo12 = fullDataObject.calloutNotation.lineProps) === null || _fullDataObject$callo12 === void 0 ? void 0 : _fullDataObject$callo12.forceArrowBase;
        var startPointN = isDimensionLine ? 0 : (_fullDataObject$callo13 = fullDataObject.calloutNotation.lineProps) === null || _fullDataObject$callo13 === void 0 ? void 0 : _fullDataObject$callo13.startPoint;
        var endPointN = isDimensionLine ? 1 : (_fullDataObject$callo14 = fullDataObject.calloutNotation.lineProps) === null || _fullDataObject$callo14 === void 0 ? void 0 : _fullDataObject$callo14.endPoint;
        var dimensionLinePoints = ((_fullDataObject$callo15 = fullDataObject.calloutNotation.lineProps) === null || _fullDataObject$callo15 === void 0 ? void 0 : _fullDataObject$callo15.dimensionLinePoints) || [];
        line.getPoint(typeof startPointN === "number" ? startPointN : 0.1, startPoint);
        line.getPoint(typeof endPointN === "number" ? endPointN : 0.9, endPoint);
        var distance = startPoint.distanceTo(endPoint);
        if (distance > 2 && !((_fullDataObject$callo16 = fullDataObject.calloutNotation.lineProps) !== null && _fullDataObject$callo16 !== void 0 && _fullDataObject$callo16.disable)) {
          var _fullDataObject$callo17, _fullDataObject$callo18;
          var getRanges = function getRanges(_ref9) {
            var min = _ref9.min,
              max = _ref9.max,
              d = _ref9.d;
            var l = max - min;
            var s = l / (d + 1);
            return (0, _toConsumableArray2["default"])(Array(d)).map(function (u, i) {
              return min + (i + 1) * s;
            });
          };
          var sliceCurve = function sliceCurve(_ref10) {
            var curve = _ref10.curve,
              s = _ref10.s;
            var slicePoint = curve.getPoint(s);
            var startPoint = curve.getPoint(0);
            var endPoint = curve.getPoint(1);
            var d = 5;
            var s1Middle = getRanges({
              min: 0,
              max: s,
              d: d
            }).map(function (p) {
              return curve.getPoint(p);
            });
            var s2Middle = getRanges({
              min: s,
              max: 1,
              d: d
            }).map(function (p) {
              return curve.getPoint(p);
            });
            return [new THREE.CatmullRomCurve3([startPoint].concat((0, _toConsumableArray2["default"])(s1Middle), [slicePoint])), new THREE.CatmullRomCurve3([slicePoint].concat((0, _toConsumableArray2["default"])(s2Middle), [endPoint]))];
          };
          var getFrenet = function getFrenet(_ref11) {
            var curve = _ref11.curve,
              n = _ref11.n,
              r = _ref11.r,
              s = _ref11.s;
            var tubeGeo = new THREE.TubeGeometry(curve, n, r, s);
            var wireFrame = new THREE.WireframeGeometry(tubeGeo);
            var l = wireFrame.attributes.position.count;
            var points = [curve.getPoint(0)].concat((0, _toConsumableArray2["default"])((0, _toConsumableArray2["default"])(Array(l)).map(function (u, i) {
              return new THREE.Vector3().fromBufferAttribute(wireFrame.attributes.position, i);
            }).filter(function (v, i) {
              return !(i % (s * s));
            })), [curve.getPoint(1)]);
            return new THREE.CatmullRomCurve3(points, false, "catmullrom", 1);
          };
          var line2 = new THREE.LineCurve3(startPoint, endPoint);
          var controlPoint = new THREE.Vector3();
          line2.getPoint(0.5, controlPoint);
          var maxY = startPoint.y - endPoint.y;
          var mainPoints = [startPoint, new THREE.Vector3(controlPoint.x, controlPoint.y - maxY / 3, controlPoint.z), endPoint];
          var mainCurve = (0, _construct2["default"])(THREE.QuadraticBezierCurve3, mainPoints);
          var startFrenet = getRandomInt(8, 16) / 100;
          var endFrenet = getRandomInt(25, 40) / 100;
          var rFrenet = getRandomInt(2, 4) / 10;
          var nFrenet = getRandomInt(3, 4) * 8;
          var sFrenet = 8;
          var _sliceCurve = sliceCurve({
              curve: mainCurve,
              s: startFrenet
            }),
            _sliceCurve2 = (0, _slicedToArray2["default"])(_sliceCurve, 2),
            mainCurvePart1 = _sliceCurve2[0],
            mainCurveRest = _sliceCurve2[1];
          var _sliceCurve3 = sliceCurve({
              curve: mainCurveRest,
              s: endFrenet - startFrenet
            }),
            _sliceCurve4 = (0, _slicedToArray2["default"])(_sliceCurve3, 2),
            mainCurvePart2 = _sliceCurve4[0],
            mainCurvePart3 = _sliceCurve4[1];
          var frenet = getFrenet({
            curve: mainCurvePart2,
            n: nFrenet,
            r: rFrenet,
            s: sFrenet
          });
          var arrowWidth = 1;
          var arrowEndOnMain = new THREE.Vector3();
          mainCurve.getPoint(((_fullDataObject$callo17 = fullDataObject.calloutNotation.lineProps) === null || _fullDataObject$callo17 === void 0 ? void 0 : _fullDataObject$callo17.arrowEndOnMain) || 0.7, arrowEndOnMain);
          var arrowUpEnd = new THREE.Vector3(arrowEndOnMain.x + arrowWidth / 2, arrowEndOnMain.y, arrowEndOnMain.z);
          var arrowUpControlPoint = new THREE.Vector3();
          var arrowUpLine = new THREE.LineCurve3(endPoint, arrowUpEnd);
          arrowUpLine.getPoint(0.5, arrowUpControlPoint);
          var arrowUpPoints = [endPoint, new THREE.Vector3(arrowUpControlPoint.x - arrowWidth / 3, arrowUpControlPoint.y, arrowUpControlPoint.z), arrowUpEnd];
          var arrowUp = (0, _construct2["default"])(THREE.QuadraticBezierCurve3, arrowUpPoints);
          var arrowDownEnd = new THREE.Vector3(arrowEndOnMain.x - arrowWidth / 2, arrowEndOnMain.y, arrowEndOnMain.z);
          var arrowDownControlPoint = new THREE.Vector3();
          var arrowDownLine = new THREE.LineCurve3(endPoint, arrowDownEnd);
          arrowDownLine.getPoint(0.5, arrowDownControlPoint);
          var arrowDownPoints = [endPoint, new THREE.Vector3(arrowDownControlPoint.x + arrowWidth / 3, arrowDownControlPoint.y, arrowDownControlPoint.z), arrowDownEnd];
          var arrowDown = (0, _construct2["default"])(THREE.QuadraticBezierCurve3, arrowDownPoints);
          var extendDimForArrowBase = ((_fullDataObject$callo18 = fullDataObject.calloutNotation.lineProps) === null || _fullDataObject$callo18 === void 0 ? void 0 : _fullDataObject$callo18.extendDimForArrowBase) || "x";
          var arrowBasePoints = [(0, _construct2["default"])(THREE.Vector3, (0, _toConsumableArray2["default"])(Object.keys(startPoint).map(function (key) {
            return key === extendDimForArrowBase ? startPoint[key] + arrowWidth / 2 : startPoint[key];
          }))), startPoint, (0, _construct2["default"])(THREE.Vector3, (0, _toConsumableArray2["default"])(Object.keys(startPoint).map(function (key) {
            return key === extendDimForArrowBase ? startPoint[key] - arrowWidth / 2 : startPoint[key];
          })))];
          var arrowBase = (0, _construct2["default"])(THREE.QuadraticBezierCurve3, arrowBasePoints);
          var dimensionLineClosePoints = [(0, _construct2["default"])(THREE.Vector3, (0, _toConsumableArray2["default"])(Object.keys(endPoint).map(function (key) {
            return key === extendDimForArrowBase ? endPoint[key] + arrowWidth / 2 : endPoint[key];
          }))), endPoint, (0, _construct2["default"])(THREE.Vector3, (0, _toConsumableArray2["default"])(Object.keys(endPoint).map(function (key) {
            return key === extendDimForArrowBase ? endPoint[key] - arrowWidth / 2 : endPoint[key];
          })))];
          var dimensionLineClose = (0, _construct2["default"])(THREE.QuadraticBezierCurve3, dimensionLineClosePoints);
          var dimensionLineParts = [];
          if (dimensionLinePoints) {
            dimensionLineParts.push.apply(dimensionLineParts, (0, _toConsumableArray2["default"])(dimensionLinePoints.map(function (dimensionLinePoint) {
              var position = dimensionLinePoint.position || {
                x: 0,
                y: 0,
                z: 0
              };
              var x = startPoint.x - endPoint.y + position.x;
              var y = startPoint.y - endPoint.y + position.y;
              var z = startPoint.z - endPoint.z + position.z;
              var point = {
                x: x,
                y: y,
                z: z
              };
              var points = [(0, _construct2["default"])(THREE.Vector3, (0, _toConsumableArray2["default"])(Object.keys(point).map(function (key) {
                return key === extendDimForArrowBase ? point[key] + arrowWidth / 2 : point[key];
              }))), new THREE.Vector3(x, y, z), (0, _construct2["default"])(THREE.Vector3, (0, _toConsumableArray2["default"])(Object.keys(point).map(function (key) {
                return key === extendDimForArrowBase ? point[key] - arrowWidth / 2 : point[key];
              })))];
              return (0, _construct2["default"])(THREE.QuadraticBezierCurve3, points);
            })));
          }
          var arrowConnectPoints = [arrowUpEnd, arrowEndOnMain, arrowDownEnd];
          var arrowConnect = (0, _construct2["default"])(THREE.QuadraticBezierCurve3, arrowConnectPoints);
          var frenetParts = disableFrenet ? [mainCurve] : [mainCurvePart1, frenet, mainCurvePart3];
          return [].concat((0, _toConsumableArray2["default"])(shuffleArray([[mainCurve], [mainCurve], [mainCurve], [mainCurve], frenetParts])[0]), (0, _toConsumableArray2["default"])(forceArrowBase ? [arrowBase] : shuffleArray([[arrowBase], [arrowBase], []])[0]), (0, _toConsumableArray2["default"])(isDimensionLine ? [dimensionLineClose].concat(dimensionLineParts) : [arrowUp, arrowDown].concat((0, _toConsumableArray2["default"])(shuffleArray([[arrowConnect], [arrowConnect], []])[0]))));
        }
        return null;
      };
      var refreshText = function refreshText() {
        var _fullDataObject$callo19, _fullDataObject$callo20, _fullDataObject$callo21;
        var material = new THREE.MeshBasicMaterial({
          color: fullDataObject.calloutNotation.color || 0x000000,
          transparent: true,
          opacity: fullDataObject.calloutNotation.opacity || 1,
          side: THREE.DoubleSide
        });
        var font = threeJs.fonts[fullDataObject.calloutNotation.font].font;
        var message = fullDataObject.calloutNotation.text;
        var shapes = font.generateShapes(message, fullDataObject.calloutNotation.size || 1);
        var geometry = new THREE.ShapeGeometry(shapes);
        geometry.computeBoundingBox();
        var bounding = {
          center: -0.5 * (geometry.boundingBox.max.x - geometry.boundingBox.min.x),
          left: 0,
          right: -(geometry.boundingBox.max.x - geometry.boundingBox.min.x)
        };
        geometry.translate(bounding[fullDataObject.calloutNotation.boundingX || "center"], 0, 0);
        textMesh = new THREE.Mesh(geometry, material);
        textMesh.position.x = textMeshPosition.x;
        textMesh.position.y = textMeshPosition.y;
        textMesh.position.z = textMeshPosition.z;
        textMesh.rotation.x = ((_fullDataObject$callo19 = fullDataObject.calloutNotation.rotation) === null || _fullDataObject$callo19 === void 0 ? void 0 : _fullDataObject$callo19.x) || 0;
        textMesh.rotation.y = ((_fullDataObject$callo20 = fullDataObject.calloutNotation.rotation) === null || _fullDataObject$callo20 === void 0 ? void 0 : _fullDataObject$callo20.y) || 0;
        textMesh.rotation.z = ((_fullDataObject$callo21 = fullDataObject.calloutNotation.rotation) === null || _fullDataObject$callo21 === void 0 ? void 0 : _fullDataObject$callo21.z) || 0;
        calloutNotation.add(textMesh);
        addToLayers(calloutNotation, 2, {
          camera: cameraDataForCalloutNotation
        });
      };
      var boundingOrigin = {
        center: 0,
        left: w / 2,
        right: -(w / 2)
      };
      var textMeshPosition = {};
      textMeshPosition.x = boundingOrigin[fullDataObject.calloutNotation.boundingX || "center"] + ((_fullDataObject$callo4 = fullDataObject.calloutNotation.position) === null || _fullDataObject$callo4 === void 0 ? void 0 : _fullDataObject$callo4.x) || 0;
      textMeshPosition.y = ((_fullDataObject$callo5 = fullDataObject.calloutNotation.position) === null || _fullDataObject$callo5 === void 0 ? void 0 : _fullDataObject$callo5.y) || 0;
      textMeshPosition.z = ((_fullDataObject$callo6 = fullDataObject.calloutNotation.position) === null || _fullDataObject$callo6 === void 0 ? void 0 : _fullDataObject$callo6.z) || 0;
      var lineWidth = typeof ((_fullDataObject$callo7 = fullDataObject.calloutNotation.lineProps) === null || _fullDataObject$callo7 === void 0 ? void 0 : _fullDataObject$callo7.linewidth) === "number" ? 0.075 * fullDataObject.calloutNotation.lineProps.linewidth : 0.075;
      var meshLinesMaterial = new THREE.MeshBasicMaterial({
        color: ((_fullDataObject$callo8 = fullDataObject.calloutNotation.lineProps) === null || _fullDataObject$callo8 === void 0 ? void 0 : _fullDataObject$callo8.color) || fullDataObject.calloutNotation.color || 0x000000,
        transparent: true,
        opacity: typeof ((_fullDataObject$callo9 = fullDataObject.calloutNotation.lineProps) === null || _fullDataObject$callo9 === void 0 ? void 0 : _fullDataObject$callo9.opacity) === "number" ? fullDataObject.calloutNotation.lineProps.opacity : 0.4,
        alphaToCoverage: true
      });
      var GetMesh = THREE.Mesh;
      var getGeometry = function getGeometry(curve) {
        return new THREE.TubeGeometry(curve, threeJs.renderType === "SVG" ? 20 : 200, lineWidth / 2, threeJs.renderType === "SVG" ? 4 : 8, false);
      };
      var curves = getCurves();
      if (curves) {
        curves.forEach(function (curve) {
          var meshLine = new GetMesh(getGeometry(curve), meshLinesMaterial);
          calloutNotation.add(meshLine);
        });
      }
      var textMesh;
      var textLookAtCamera = !fullDataObject.calloutNotation.disableLookAtCamera;
      if (threeJs.fonts && threeJs.fonts[fullDataObject.calloutNotation.font]) {
        if (threeJs.fonts[fullDataObject.calloutNotation.font].ready) {
          refreshText();
        } else {
          threeJs.fonts[fullDataObject.calloutNotation.font].listeners.push(refreshText);
        }
      } else {
        threeJs.fonts[fullDataObject.calloutNotation.font] = {
          loader: new FontLoader(),
          listeners: [refreshText]
        };
        threeJs.fonts[fullDataObject.calloutNotation.font].loader.load(fullDataObject.calloutNotation.font, function (response) {
          threeJs.fonts[fullDataObject.calloutNotation.font].font = response;
          threeJs.fonts[fullDataObject.calloutNotation.font].ready = true;
          var listeners = (0, _toConsumableArray2["default"])(threeJs.fonts[fullDataObject.calloutNotation.font].listeners);
          listeners.forEach(function (listener) {
            listener();
          });
        });
      }
      onRenderFunctions.push(function calloutNotationOnRender(_ref12) {
        var camera = _ref12.camera;
        if (camera) {
          if (textMesh && textLookAtCamera) {
            textMesh.setRotationFromMatrix(camera.matrixWorld);
          }
        }
      });
    }
    addToLayers(calloutNotation, 2, {
      camera: cameraDataForCalloutNotation
    });
    return calloutNotation;
  }
  function generateMesh(threeJs) {
    var geometryType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "box";
    var geometryProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var lineProps = arguments.length > 3 ? arguments[3] : undefined;
    var w = arguments.length > 4 ? arguments[4] : undefined;
    var h = arguments.length > 5 ? arguments[5] : undefined;
    var d = arguments.length > 6 ? arguments[6] : undefined;
    var materialProps = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
    var fullDataObject = arguments.length > 8 ? arguments[8] : undefined;
    var objects = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : new THREE.Group();
    var onRenderFunctions = [];
    var parentContainer = threeJs.parentContainer;
    var materialParameters = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, defaultMaterialProps), materialProps);
    var lineOpacity = typeof (lineProps === null || lineProps === void 0 ? void 0 : lineProps.opacity) === "number" ? lineProps === null || lineProps === void 0 ? void 0 : lineProps.opacity : threeJs.lineProps.opacity;
    var shadow = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, threeJs.shadow ? (0, _objectSpread2["default"])({}, threeJs.shadow) : {}), fullDataObject !== null && fullDataObject !== void 0 && fullDataObject.shadow ? (0, _objectSpread2["default"])({}, fullDataObject.shadow) : {});
    var mesh = new THREE.Object3D();
    var meshLines = new THREE.Object3D();
    if (threeJs.renderType === "WebGL") {
      var webGLMeshAndLines = getMeshAndLinesForWebGL({
        threeJs: threeJs,
        lineProps: lineProps,
        lineOpacity: lineOpacity,
        materialParameters: materialParameters,
        w: w,
        h: h,
        d: d,
        geometryType: geometryType,
        geometryProps: geometryProps,
        shadow: shadow,
        fullDataObject: fullDataObject
      });
      mesh = webGLMeshAndLines.mesh;
      meshLines = webGLMeshAndLines.meshLines;
    }
    if (threeJs.renderType === "SVG") {
      var svgMeshAndLines = getMeshAndLinesForSvg({
        threeJs: threeJs,
        lineProps: lineProps,
        lineOpacity: lineOpacity,
        materialParameters: materialParameters,
        w: w,
        h: h,
        d: d,
        geometryType: geometryType,
        geometryProps: geometryProps,
        shadow: shadow,
        fullDataObject: fullDataObject,
        parentContainer: parentContainer
      });
      mesh = svgMeshAndLines.mesh;
      meshLines = svgMeshAndLines.mesh;
    }
    addToLayers(meshLines, 0, fullDataObject);
    var editLines = getEditLines({
      threeJs: threeJs,
      materialParameters: materialParameters,
      w: w,
      h: h,
      d: d,
      shadow: shadow,
      fullDataObject: fullDataObject,
      parentContainer: parentContainer
    });
    var calloutNotation = getCalloutNotation({
      threeJs: threeJs,
      w: w,
      fullDataObject: fullDataObject,
      onRenderFunctions: onRenderFunctions
    });
    objects.userData.onRender = function (p) {
      onRenderFunctions.forEach(function (render) {
        render(p);
      });
    };
    objects.userData.geometryType = geometryType;
    objects.userData.geometryProps = geometryProps;
    objects.userData.lineProps = lineProps;
    objects.userData.width = w;
    objects.userData.height = h;
    objects.userData.depth = d;
    objects.userData.material = (0, _objectSpread2["default"])({}, materialProps);
    objects.userData.data = fullDataObject;
    objects.add(mesh);
    objects.add(meshLines);
    objects.add(editLines);
    objects.add(calloutNotation);
    return objects;
  }
  function createTween(_ref13) {
    var threeJs = _ref13.threeJs,
      from = _ref13.from,
      to = _ref13.to,
      _ref13$time = _ref13.time,
      time = _ref13$time === void 0 ? 1000 : _ref13$time,
      easingFunction = _ref13.easingFunction,
      easingType = _ref13.easingType,
      update = _ref13.update,
      resolve = _ref13.resolve,
      group = _ref13.group;
    var f = {
      pX: from.position.x,
      pY: from.position.y,
      pZ: from.position.z,
      rX: from.rotation.x,
      rY: from.rotation.y,
      rZ: from.rotation.z
    };
    var s = (0, _objectSpread2["default"])({}, f);
    var t = {
      pX: to.position.x,
      pY: to.position.y,
      pZ: to.position.z,
      rX: to.rotation.x,
      rY: to.rotation.y,
      rZ: to.rotation.z
    };
    var pVX = Math.abs(t.pX - f.pX);
    var pVY = Math.abs(t.pY - f.pY);
    var pVZ = Math.abs(t.pZ - f.pZ);
    var maxDim = pVX > pVY && pVX > pVZ ? "x" : pVY > pVZ ? "y" : "z";
    var maxVDim = maxDim === "x" ? pVX : maxDim === "y" ? pVY : pVZ;
    var tween = new TWEEN.Tween(f, group).to(t, time).onUpdate(function () {
      var pDim = "p" + maxDim.toUpperCase();
      var elapsedDim = Math.abs(f[pDim] - s[pDim]);
      update((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, f), {}, {
        opacity: elapsedDim / maxVDim
      }));
    }).easing(TWEEN.Easing[easingFunction || threeJs.animationProps.easingFunction][easingType || threeJs.animationProps.easingType]).onComplete(function () {
      var pDim = "p" + maxDim.toUpperCase();
      var elapsedDim = Math.abs(t[pDim] - s[pDim]);
      update((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, t), {}, {
        opacity: elapsedDim / maxVDim
      }));
      tween.stop();
      if (threeJs.runningTweens.indexOf(tween) > -1) {
        threeJs.runningTweens.splice(threeJs.runningTweens.indexOf(tween), 1);
      }
      resolve();
    });
    threeJs.runningTweens.push(tween);
    return tween;
  }
  var addObjectsAnimations = {
    "default": function () {
      var _addObjectsDefault = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee7(threeJs, data, _final) {
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return new Promise( /*#__PURE__*/function () {
                var _ref14 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee6(resolve) {
                  var goal, animTime, child, childTweens, childTweenGroup, childCompletedTweens, startedChildTween, newChildTweens, newChildTweenGroup, newChildCompletedTweens, startedNewChildTween, positions, materials, rotations, setOpacityWithChildren, childAnim, newChildAnim, childPromise, newChildPromise;
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        setOpacityWithChildren = function _setOpacityWithChildr(child, newOpacity) {
                          setOpacity({
                            child: child.children[0],
                            newOpacity: newOpacity
                          });
                          setOpacity({
                            child: child.children[1],
                            newOpacity: newOpacity
                          });
                          if (child.children[2]) {
                            setOpacity({
                              child: child.children[2],
                              newOpacity: newOpacity
                            });
                          }
                          if (child.children[3]) {
                            setOpacity({
                              child: child.children[3],
                              newOpacity: newOpacity
                            });
                          }
                        };
                        threeJs.addObjectsAnimationChildIsRunning = true;
                        threeJs.addObjectsAnimationNewChildIsRunning = true;
                        threeJs.addObjectsAnimationIsFinal = _final;
                        threeJs.addObjectsAnimationIsRunning = true;
                        goal = threeJs.animationProps.addObjectsDefaultGoal;
                        animTime = threeJs.animationProps.addObjectsAnimationTime;
                        child = (0, _toConsumableArray2["default"])(threeJs.objects.children);
                        childTweens = [];
                        childTweenGroup = new TWEEN.Group();
                        childCompletedTweens = 0;
                        startedChildTween = false;
                        newChildTweens = [];
                        newChildTweenGroup = new TWEEN.Group();
                        newChildCompletedTweens = 0;
                        startedNewChildTween = false;
                        positions = data.map(function (d) {
                          return d.position;
                        });
                        materials = data.map(function (d) {
                          return d.material;
                        });
                        rotations = data.map(function (d) {
                          return d.rotation || {
                            x: 0,
                            y: 0,
                            z: 0
                          };
                        });
                        child.forEach(function (child) {
                          var _object$userData, _object$userData$data, _object$userData$data2, _object$userData2, _object$userData2$dat, _object$userData2$dat2, _object$userData3, _object$userData3$dat, _object$userData3$dat2, _object$userData4, _object$userData4$dat, _object$userData4$dat2;
                          var object = child;
                          var orientation = getMoveAxis(object);
                          var p = object.position[orientation] > 0 ? 1 : -1;
                          var from = {
                            position: (0, _objectSpread2["default"])({}, object.position),
                            rotation: {
                              x: object.rotation.x,
                              y: object.rotation.y,
                              z: object.rotation.z
                            }
                          };
                          var to = {
                            position: (0, _objectSpread2["default"])({}, from.position),
                            rotation: (0, _objectSpread2["default"])({}, from.rotation)
                          };
                          var eGoal = typeof ((_object$userData = object.userData) === null || _object$userData === void 0 ? void 0 : (_object$userData$data = _object$userData.data) === null || _object$userData$data === void 0 ? void 0 : (_object$userData$data2 = _object$userData$data.animationProps) === null || _object$userData$data2 === void 0 ? void 0 : _object$userData$data2.goal) === "number" ? object.userData.data.animationProps.goal : goal;
                          to.position[orientation] = to.position[orientation] + eGoal * p;
                          var tween = createTween({
                            threeJs: threeJs,
                            from: object,
                            to: to,
                            time: getRandomInt.apply(void 0, (0, _toConsumableArray2["default"])((_object$userData2 = object.userData) !== null && _object$userData2 !== void 0 && (_object$userData2$dat = _object$userData2.data) !== null && _object$userData2$dat !== void 0 && (_object$userData2$dat2 = _object$userData2$dat.animationProps) !== null && _object$userData2$dat2 !== void 0 && _object$userData2$dat2.addObjectsAnimationTime ? object.userData.data.animationProps.addObjectsAnimationTime : animTime)),
                            easingFunction: (_object$userData3 = object.userData) !== null && _object$userData3 !== void 0 && (_object$userData3$dat = _object$userData3.data) !== null && _object$userData3$dat !== void 0 && (_object$userData3$dat2 = _object$userData3$dat.animationProps) !== null && _object$userData3$dat2 !== void 0 && _object$userData3$dat2.easingFunction ? object.userData.data.animationProps.easingFunction : undefined,
                            easingType: (_object$userData4 = object.userData) !== null && _object$userData4 !== void 0 && (_object$userData4$dat = _object$userData4.data) !== null && _object$userData4$dat !== void 0 && (_object$userData4$dat2 = _object$userData4$dat.animationProps) !== null && _object$userData4$dat2 !== void 0 && _object$userData4$dat2.easingType ? object.userData.data.animationProps.easingType : undefined,
                            update: function update(_ref15) {
                              var pX = _ref15.pX,
                                pY = _ref15.pY,
                                pZ = _ref15.pZ,
                                rX = _ref15.rX,
                                rY = _ref15.rY,
                                rZ = _ref15.rZ,
                                opacity = _ref15.opacity;
                              object.position.x = pX;
                              object.position.y = pY;
                              object.position.z = pZ;
                              object.rotation.x = rX;
                              object.rotation.y = rY;
                              object.rotation.z = rZ;
                              var newOpacity = 1 - opacity;
                              setOpacityWithChildren(object, newOpacity < 0.2 ? 0 : scaleValue(newOpacity * 100, [20, 100], [0, 100]) / 100);
                              threeJs.updateShadowMap();
                            },
                            resolve: function resolve() {
                              object.position.x = to.position.x;
                              object.position.y = to.position.y;
                              object.position.z = to.position.z;
                              object.rotation.x = to.rotation.x;
                              object.rotation.y = to.rotation.y;
                              object.rotation.z = to.rotation.z;
                              childCompletedTweens = childCompletedTweens + 1;
                              threeJs.objects.remove(child);
                              threeJs.updateShadowMap();
                              tween.stop();
                            },
                            group: childTweenGroup
                          });
                          childTweens.push(tween);
                        });
                        data.forEach(function (d, i) {
                          var _d$animationProps, _d$animationProps2, _d$animationProps3, _d$animationProps4;
                          var material = materials[i];
                          var position = positions[i];
                          var rotation = rotations[i];
                          var object = generateMesh(threeJs, d.geometryType, d.geometryProps, d.lineProps, d.width, d.height, d.depth, material, d);
                          var rotationOrder = d.rotationOrder;
                          if (rotationOrder) {
                            object.rotation._order = rotationOrder;
                          }
                          var from = {
                            position: {
                              x: position.x || 0,
                              y: position.y || 0,
                              z: position.z || 0
                            },
                            rotation: {
                              x: rotation.x || 0,
                              y: rotation.y || 0,
                              z: rotation.z || 0
                            }
                          };
                          var to = {
                            position: (0, _objectSpread2["default"])({}, from.position),
                            rotation: (0, _objectSpread2["default"])({}, from.rotation)
                          };
                          var orientation = getMoveAxis(object);
                          var p = object.position[orientation] > 0 ? 1 : -1;
                          var eGoal = typeof ((_d$animationProps = d.animationProps) === null || _d$animationProps === void 0 ? void 0 : _d$animationProps.goal) === "number" ? d.animationProps.goal : goal;
                          from.position[orientation] = from.position[orientation] + eGoal * 2 * p;
                          object.position.x = from.position.x;
                          object.position.y = from.position.y;
                          object.position.z = from.position.z;
                          object.rotation.x = from.rotation.x;
                          object.rotation.y = from.rotation.y;
                          object.rotation.z = from.rotation.z;
                          setOpacityWithChildren(object, 0);
                          threeJs.objects.add(object);
                          object.userData.dataIndex = i;
                          var tween = createTween({
                            threeJs: threeJs,
                            from: object,
                            to: to,
                            time: getRandomInt.apply(void 0, (0, _toConsumableArray2["default"])((_d$animationProps2 = d.animationProps) !== null && _d$animationProps2 !== void 0 && _d$animationProps2.addObjectsAnimationTime ? d.animationProps.addObjectsAnimationTime : animTime)),
                            easingFunction: (_d$animationProps3 = d.animationProps) !== null && _d$animationProps3 !== void 0 && _d$animationProps3.easingFunction ? d.animationProps.easingFunction : undefined,
                            easingType: (_d$animationProps4 = d.animationProps) !== null && _d$animationProps4 !== void 0 && _d$animationProps4.easingType ? d.animationProps.easingType : undefined,
                            update: function update(_ref16) {
                              var pX = _ref16.pX,
                                pY = _ref16.pY,
                                pZ = _ref16.pZ,
                                rX = _ref16.rX,
                                rY = _ref16.rY,
                                rZ = _ref16.rZ,
                                opacity = _ref16.opacity;
                              object.position.x = pX;
                              object.position.y = pY;
                              object.position.z = pZ;
                              object.rotation.x = rX;
                              object.rotation.y = rY;
                              object.rotation.z = rZ;
                              var newOpacity = opacity < 0.2 ? 0 : opacity < 0.9 ? scaleValue(opacity * 100, [20, 90], [20, 40]) / 100 : scaleValue(opacity * 100, [90, 100], [40, 100]) / 100;
                              setOpacityWithChildren(object, newOpacity);
                              threeJs.updateShadowMap();
                            },
                            resolve: function resolve() {
                              object.position.x = to.position.x;
                              object.position.y = to.position.y;
                              object.position.z = to.position.z;
                              object.rotation.x = to.rotation.x;
                              object.rotation.y = to.rotation.y;
                              object.rotation.z = to.rotation.z;
                              newChildCompletedTweens = newChildCompletedTweens + 1;
                              threeJs.updateShadowMap();
                              tween.stop();
                            },
                            group: newChildTweenGroup
                          });
                          newChildTweens.push(tween);
                        });
                        childAnim = function childAnim(time) {
                          if (!startedChildTween) {
                            childTweens.forEach(function (tween) {
                              return tween.start(time);
                            });
                            startedChildTween = true;
                          }
                          childTweenGroup.update(time);
                          threeJs.updateShadowMap();
                        };
                        newChildAnim = function newChildAnim(time) {
                          if (!startedNewChildTween) {
                            newChildTweens.forEach(function (tween) {
                              return tween.start(time);
                            });
                            startedNewChildTween = true;
                          }
                          newChildTweenGroup.update(time);
                        };
                        threeJs.animationBeforeRender = function (time) {
                          if (childAnim) {
                            childAnim(time);
                          }
                          if (_final && !childAnim || !_final) {
                            if (newChildAnim) {
                              newChildAnim(time);
                            }
                          }
                        };
                        childPromise = new Promise( /*#__PURE__*/function () {
                          var _ref17 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(resolve) {
                            var sI, cI;
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
                              while (1) switch (_context3.prev = _context3.next) {
                                case 0:
                                  sI = typeof window !== "undefined" && window.timeWeb ? window.timeWeb.o.setInterval : setInterval;
                                  cI = typeof window !== "undefined" && window.timeWeb ? window.timeWeb.o.clearInterval : clearInterval;
                                  _context3.next = 4;
                                  return new Promise(function (resolve) {
                                    var _int = sI( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
                                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
                                        while (1) switch (_context.prev = _context.next) {
                                          case 0:
                                            if (startedChildTween && childCompletedTweens === childTweens.length) {
                                              cI(_int);
                                              resolve();
                                            }
                                          case 1:
                                          case "end":
                                            return _context.stop();
                                        }
                                      }, _callee);
                                    })), 1);
                                  });
                                case 4:
                                  threeJs.addObjectsAnimationChildIsRunning = false;
                                  if (!_final) {
                                    _context3.next = 10;
                                    break;
                                  }
                                  _context3.next = 8;
                                  return new Promise(function (resolve) {
                                    return setTimeout(resolve, threeJs.animationProps.waitTimeFinalEnd);
                                  });
                                case 8:
                                  _context3.next = 10;
                                  return new Promise(function (resolve) {
                                    var _int2 = sI( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
                                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
                                        while (1) switch (_context2.prev = _context2.next) {
                                          case 0:
                                            if (!threeJs.waitForCameraPosFromUpdateObjects) {
                                              cI(_int2);
                                              resolve();
                                            }
                                          case 1:
                                          case "end":
                                            return _context2.stop();
                                        }
                                      }, _callee2);
                                    })), 1);
                                  });
                                case 10:
                                  childAnim = null;
                                  resolve();
                                case 12:
                                case "end":
                                  return _context3.stop();
                              }
                            }, _callee3);
                          }));
                          return function (_x7) {
                            return _ref17.apply(this, arguments);
                          };
                        }());
                        newChildPromise = new Promise( /*#__PURE__*/function () {
                          var _ref20 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5(resolve) {
                            var sI, cI;
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
                              while (1) switch (_context5.prev = _context5.next) {
                                case 0:
                                  sI = typeof window !== "undefined" && window.timeWeb ? window.timeWeb.o.setInterval : setInterval;
                                  cI = typeof window !== "undefined" && window.timeWeb ? window.timeWeb.o.clearInterval : clearInterval;
                                  _context5.next = 4;
                                  return new Promise(function (resolve) {
                                    var _int3 = sI( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4() {
                                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
                                        while (1) switch (_context4.prev = _context4.next) {
                                          case 0:
                                            if (startedNewChildTween && newChildCompletedTweens === newChildTweens.length) {
                                              cI(_int3);
                                              resolve();
                                            }
                                          case 1:
                                          case "end":
                                            return _context4.stop();
                                        }
                                      }, _callee4);
                                    })), 1);
                                  });
                                case 4:
                                  newChildAnim = null;
                                  threeJs.addObjectsAnimationNewChildIsRunning = false;
                                  resolve();
                                case 7:
                                case "end":
                                  return _context5.stop();
                              }
                            }, _callee5);
                          }));
                          return function (_x8) {
                            return _ref20.apply(this, arguments);
                          };
                        }());
                        _context6.next = 28;
                        return Promise.all([childPromise, newChildPromise]);
                      case 28:
                        threeJs.addObjectsAnimationIsRunning = false;
                        threeJs.animationBeforeRender = null;
                        resolve();
                      case 31:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x6) {
                  return _ref14.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function addObjectsDefault(_x3, _x4, _x5) {
        return _addObjectsDefault.apply(this, arguments);
      }
      return addObjectsDefault;
    }(),
    fromCurrentToNext: function () {
      var _addObjectsFromCurrentToNext = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee13(threeJs, data) {
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return new Promise( /*#__PURE__*/function () {
                var _ref22 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee12(resolve) {
                  var goal, animTime, child, childTweens, childTweenGroup, childCompletedTweens, startedChildTween, newChildTweens, newChildTweenGroup, newChildCompletedTweens, startedNewChildTween, positions, materials, rotations, tweensWithRandomAfterCreateObjects, setOpacityWithChildren, childAnim, newChildAnim, childPromise, newChildPromise;
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee12$(_context12) {
                    while (1) switch (_context12.prev = _context12.next) {
                      case 0:
                        setOpacityWithChildren = function _setOpacityWithChildr2(child, newOpacity) {
                          setOpacity({
                            child: child.children[0],
                            newOpacity: newOpacity
                          });
                          setOpacity({
                            child: child.children[1],
                            newOpacity: newOpacity
                          });
                          if (child.children[2]) {
                            setOpacity({
                              child: child.children[2],
                              newOpacity: newOpacity
                            });
                          }
                          if (child.children[3]) {
                            setOpacity({
                              child: child.children[3],
                              newOpacity: newOpacity
                            });
                          }
                        };
                        threeJs.addObjectsAnimationChildIsRunning = true;
                        threeJs.addObjectsAnimationNewChildIsRunning = true;
                        threeJs.addObjectsAnimationIsFinal = false;
                        threeJs.addObjectsAnimationIsRunning = true;
                        goal = threeJs.animationProps.addObjectsFromCurrentToNextGoal;
                        animTime = threeJs.animationProps.addObjectsAnimationTime;
                        child = (0, _toConsumableArray2["default"])(threeJs.objects.children);
                        childTweens = [];
                        childTweenGroup = new TWEEN.Group();
                        childCompletedTweens = 0;
                        startedChildTween = false;
                        newChildTweens = [];
                        newChildTweenGroup = new TWEEN.Group();
                        newChildCompletedTweens = 0;
                        startedNewChildTween = false;
                        positions = data.map(function (d) {
                          return d.position;
                        });
                        materials = data.map(function (d) {
                          return d.material;
                        });
                        rotations = data.map(function (d) {
                          return d.rotation || {
                            x: 0,
                            y: 0,
                            z: 0
                          };
                        });
                        tweensWithRandomAfterCreateObjects = [];
                        child.forEach(function (child, i) {
                          var _object$userData5, _object$userData5$dat, _object$userData5$dat2;
                          var object = child;
                          var orientation = getMoveAxis(object);
                          var p = object.position[orientation] > 0 ? 1 : -1;
                          var from = {
                            position: (0, _objectSpread2["default"])({}, object.position),
                            rotation: {
                              x: object.rotation.x,
                              y: object.rotation.y,
                              z: object.rotation.z
                            }
                          };
                          var to = {
                            position: (0, _objectSpread2["default"])({}, from.position),
                            rotation: (0, _objectSpread2["default"])({}, from.rotation)
                          };
                          var eGoal = typeof ((_object$userData5 = object.userData) === null || _object$userData5 === void 0 ? void 0 : (_object$userData5$dat = _object$userData5.data) === null || _object$userData5$dat === void 0 ? void 0 : (_object$userData5$dat2 = _object$userData5$dat.animationProps) === null || _object$userData5$dat2 === void 0 ? void 0 : _object$userData5$dat2.goal) === "number" ? object.userData.data.animationProps.goal : goal;
                          to.position[orientation] = to.position[orientation] + eGoal * p;
                          tweensWithRandomAfterCreateObjects.push(function () {
                            var _object$userData6, _object$userData6$dat, _object$userData6$dat2, _object$userData7, _object$userData7$dat, _object$userData7$dat2, _object$userData8, _object$userData8$dat, _object$userData8$dat2;
                            var tween = createTween({
                              threeJs: threeJs,
                              from: object,
                              to: to,
                              time: data[i] ? 100 : getRandomInt.apply(void 0, (0, _toConsumableArray2["default"])((_object$userData6 = object.userData) !== null && _object$userData6 !== void 0 && (_object$userData6$dat = _object$userData6.data) !== null && _object$userData6$dat !== void 0 && (_object$userData6$dat2 = _object$userData6$dat.animationProps) !== null && _object$userData6$dat2 !== void 0 && _object$userData6$dat2.addObjectsAnimationTime ? object.userData.data.animationProps.addObjectsAnimationTime : animTime)),
                              easingFunction: (_object$userData7 = object.userData) !== null && _object$userData7 !== void 0 && (_object$userData7$dat = _object$userData7.data) !== null && _object$userData7$dat !== void 0 && (_object$userData7$dat2 = _object$userData7$dat.animationProps) !== null && _object$userData7$dat2 !== void 0 && _object$userData7$dat2.easingFunction ? object.userData.data.animationProps.easingFunction : undefined,
                              easingType: (_object$userData8 = object.userData) !== null && _object$userData8 !== void 0 && (_object$userData8$dat = _object$userData8.data) !== null && _object$userData8$dat !== void 0 && (_object$userData8$dat2 = _object$userData8$dat.animationProps) !== null && _object$userData8$dat2 !== void 0 && _object$userData8$dat2.easingType ? object.userData.data.animationProps.easingType : undefined,
                              update: function update(_ref23) {
                                var pX = _ref23.pX,
                                  pY = _ref23.pY,
                                  pZ = _ref23.pZ,
                                  rX = _ref23.rX,
                                  rY = _ref23.rY,
                                  rZ = _ref23.rZ,
                                  opacity = _ref23.opacity;
                                object.position.x = pX;
                                object.position.y = pY;
                                object.position.z = pZ;
                                object.rotation.x = rX;
                                object.rotation.y = rY;
                                object.rotation.z = rZ;
                                var newOpacity = 1 - opacity;
                                setOpacityWithChildren(object, newOpacity < 0.2 ? 0 : scaleValue(newOpacity * 100, [20, 100], [0, 100]) / 100);
                                threeJs.updateShadowMap();
                              },
                              resolve: function resolve() {
                                object.position.x = to.position.x;
                                object.position.y = to.position.y;
                                object.position.z = to.position.z;
                                object.rotation.x = to.rotation.x;
                                object.rotation.y = to.rotation.y;
                                object.rotation.z = to.rotation.z;
                                childCompletedTweens = childCompletedTweens + 1;
                                threeJs.objects.remove(child);
                                threeJs.updateShadowMap();
                                tween.stop();
                              },
                              group: childTweenGroup
                            });
                            childTweens.push(tween);
                          });
                        });
                        data.forEach(function (d, i) {
                          var material = materials[i];
                          var position = positions[i];
                          var rotation = rotations[i];
                          var object = generateMesh(threeJs, d.geometryType, d.geometryProps, d.lineProps, d.width, d.height, d.depth, material, d);
                          var rotationOrder = d.rotationOrder;
                          if (rotationOrder) {
                            object.rotation._order = rotationOrder;
                          }
                          var orientation = getMoveAxis(object);
                          if (child[i]) {
                            object.position.x = child[i].position.x;
                            object.position.y = child[i].position.y;
                            object.position.z = child[i].position.z;
                          } else {
                            object.position.x = position.x || 0;
                            object.position.y = position.y || 0;
                            object.position.z = position.z || 0;
                          }
                          if (child[i]) {
                            object.rotation.x = child[i].rotation.x;
                            object.rotation.y = child[i].rotation.y;
                            object.rotation.z = child[i].rotation.z;
                          } else {
                            object.rotation.x = rotation.x || 0;
                            object.rotation.y = rotation.y || 0;
                            object.rotation.z = rotation.z || 0;
                          }
                          var to = {
                            position: {
                              x: position.x || 0,
                              y: position.y || 0,
                              z: position.z || 0
                            },
                            rotation: {
                              x: rotation.x || 0,
                              y: rotation.y || 0,
                              z: rotation.z || 0
                            }
                          };
                          if (child[i]) {
                            threeJs.objects.remove(child[i]);
                          }
                          if (!child[i]) {
                            var _d$animationProps5;
                            var _p = object.position[orientation] > 0 ? 1 : -1;
                            var eGoal = typeof ((_d$animationProps5 = d.animationProps) === null || _d$animationProps5 === void 0 ? void 0 : _d$animationProps5.goal) === "number" ? d.animationProps.goal : goal;
                            object.position[orientation] = object.position[orientation] + eGoal * _p;
                            setOpacityWithChildren(object, 0);
                          }
                          threeJs.objects.add(object);
                          object.userData.dataIndex = i;
                          var notEqual = ["x", "y", "z"].find(function (axis) {
                            return object.position[axis] !== position[axis] || object.rotation[axis] !== rotation[axis];
                          });
                          tweensWithRandomAfterCreateObjects.push(function () {
                            var _d$animationProps6, _d$animationProps7, _d$animationProps8;
                            var tween = createTween({
                              threeJs: threeJs,
                              from: object,
                              to: to,
                              time: notEqual ? getRandomInt.apply(void 0, (0, _toConsumableArray2["default"])((_d$animationProps6 = d.animationProps) !== null && _d$animationProps6 !== void 0 && _d$animationProps6.addObjectsAnimationTime ? d.animationProps.addObjectsAnimationTime : animTime)) : 100,
                              easingFunction: (_d$animationProps7 = d.animationProps) !== null && _d$animationProps7 !== void 0 && _d$animationProps7.easingFunction ? d.animationProps.easingFunction : undefined,
                              easingType: (_d$animationProps8 = d.animationProps) !== null && _d$animationProps8 !== void 0 && _d$animationProps8.easingType ? d.animationProps.easingType : undefined,
                              update: function update(_ref24) {
                                var pX = _ref24.pX,
                                  pY = _ref24.pY,
                                  pZ = _ref24.pZ,
                                  rX = _ref24.rX,
                                  rY = _ref24.rY,
                                  rZ = _ref24.rZ,
                                  opacity = _ref24.opacity;
                                object.position.x = pX;
                                object.position.y = pY;
                                object.position.z = pZ;
                                object.rotation.x = rX;
                                object.rotation.y = rY;
                                object.rotation.z = rZ;
                                var newOpacity = child[i] ? 1 : opacity < 0.2 ? 0 : opacity < 0.9 ? scaleValue(opacity * 100, [20, 90], [20, 40]) / 100 : scaleValue(opacity * 100, [90, 100], [40, 100]) / 100;
                                setOpacityWithChildren(object, newOpacity);
                                threeJs.updateShadowMap();
                              },
                              resolve: function resolve() {
                                object.position.x = to.position.x;
                                object.position.y = to.position.y;
                                object.position.z = to.position.z;
                                object.rotation.x = to.rotation.x;
                                object.rotation.y = to.rotation.y;
                                object.rotation.z = to.rotation.z;
                                newChildCompletedTweens = newChildCompletedTweens + 1;
                                threeJs.updateShadowMap();
                                tween.stop();
                              },
                              group: newChildTweenGroup
                            });
                            newChildTweens.push(tween);
                          });
                        });
                        tweensWithRandomAfterCreateObjects.forEach(function (f) {
                          return f();
                        });
                        childAnim = function childAnim(time) {
                          if (!startedChildTween) {
                            childTweens.forEach(function (tween) {
                              return tween.start(time);
                            });
                            startedChildTween = true;
                          }
                          childTweenGroup.update(time);
                          threeJs.updateShadowMap();
                        };
                        newChildAnim = function newChildAnim(time) {
                          if (!startedNewChildTween) {
                            newChildTweens.forEach(function (tween) {
                              return tween.start(time);
                            });
                            startedNewChildTween = true;
                          }
                          newChildTweenGroup.update(time);
                        };
                        threeJs.animationBeforeRender = function (time) {
                          if (childAnim) {
                            childAnim(time);
                          }
                          if (newChildAnim) {
                            newChildAnim(time);
                          }
                        };
                        childPromise = new Promise( /*#__PURE__*/function () {
                          var _ref25 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee9(resolve) {
                            var sI, cI;
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee9$(_context9) {
                              while (1) switch (_context9.prev = _context9.next) {
                                case 0:
                                  sI = typeof window !== "undefined" && window.timeWeb ? window.timeWeb.o.setInterval : setInterval;
                                  cI = typeof window !== "undefined" && window.timeWeb ? window.timeWeb.o.clearInterval : clearInterval;
                                  _context9.next = 4;
                                  return new Promise(function (resolve) {
                                    var _int4 = sI( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee8() {
                                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee8$(_context8) {
                                        while (1) switch (_context8.prev = _context8.next) {
                                          case 0:
                                            if (startedChildTween && childCompletedTweens === childTweens.length) {
                                              cI(_int4);
                                              resolve();
                                            }
                                          case 1:
                                          case "end":
                                            return _context8.stop();
                                        }
                                      }, _callee8);
                                    })), 1);
                                  });
                                case 4:
                                  threeJs.addObjectsAnimationChildIsRunning = false;
                                  childAnim = null;
                                  resolve();
                                case 7:
                                case "end":
                                  return _context9.stop();
                              }
                            }, _callee9);
                          }));
                          return function (_x12) {
                            return _ref25.apply(this, arguments);
                          };
                        }());
                        newChildPromise = new Promise( /*#__PURE__*/function () {
                          var _ref27 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee11(resolve) {
                            var sI, cI;
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee11$(_context11) {
                              while (1) switch (_context11.prev = _context11.next) {
                                case 0:
                                  sI = typeof window !== "undefined" && window.timeWeb ? window.timeWeb.o.setInterval : setInterval;
                                  cI = typeof window !== "undefined" && window.timeWeb ? window.timeWeb.o.clearInterval : clearInterval;
                                  _context11.next = 4;
                                  return new Promise(function (resolve) {
                                    var _int5 = sI( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee10() {
                                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee10$(_context10) {
                                        while (1) switch (_context10.prev = _context10.next) {
                                          case 0:
                                            if (startedNewChildTween && newChildCompletedTweens === newChildTweens.length) {
                                              cI(_int5);
                                              resolve();
                                            }
                                          case 1:
                                          case "end":
                                            return _context10.stop();
                                        }
                                      }, _callee10);
                                    })), 1);
                                  });
                                case 4:
                                  newChildAnim = null;
                                  threeJs.addObjectsAnimationNewChildIsRunning = false;
                                  resolve();
                                case 7:
                                case "end":
                                  return _context11.stop();
                              }
                            }, _callee11);
                          }));
                          return function (_x13) {
                            return _ref27.apply(this, arguments);
                          };
                        }());
                        _context12.next = 30;
                        return Promise.all([childPromise, newChildPromise]);
                      case 30:
                        threeJs.addObjectsAnimationIsRunning = false;
                        threeJs.animationBeforeRender = null;
                        resolve();
                      case 33:
                      case "end":
                        return _context12.stop();
                    }
                  }, _callee12);
                }));
                return function (_x11) {
                  return _ref22.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
      function addObjectsFromCurrentToNext(_x9, _x10) {
        return _addObjectsFromCurrentToNext.apply(this, arguments);
      }
      return addObjectsFromCurrentToNext;
    }()
  };
  function addObjects(_x14, _x15, _x16) {
    return _addObjects.apply(this, arguments);
  }
  function _addObjects() {
    _addObjects = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee15(threeJs, data, _final2) {
      var _threeJs$animationPro, addObjectsAnimationType, func;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            _threeJs$animationPro = threeJs.animationProps.addObjectsAnimationType, addObjectsAnimationType = _threeJs$animationPro === void 0 ? "default" : _threeJs$animationPro;
            setRandomVariables({
              threeJs: threeJs
            });
            func = _final2 ? addObjectsAnimations["default"] : addObjectsAnimations[addObjectsAnimationType] || addObjectsAnimations["default"];
            _context15.next = 5;
            return func(threeJs, data, _final2);
          case 5:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    }));
    return _addObjects.apply(this, arguments);
  }
  function addObjectsWithoutAnimation(_x17, _x18) {
    return _addObjectsWithoutAnimation.apply(this, arguments);
  }
  function _addObjectsWithoutAnimation() {
    _addObjectsWithoutAnimation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee16(threeJs, data) {
      var child, positions, materials, rotations;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            setRandomVariables({
              threeJs: threeJs
            });
            child = (0, _toConsumableArray2["default"])(threeJs.objects.children);
            child.forEach(function (child) {
              threeJs.objects.remove(child);
            });
            positions = data.map(function (d) {
              return d.position;
            });
            materials = data.map(function (d) {
              return d.material;
            });
            rotations = data.map(function (d) {
              return d.rotation || {
                x: 0,
                y: 0,
                z: 0
              };
            });
            data.forEach(function (d, i) {
              var material = materials[i];
              var position = positions[i];
              var rotation = rotations[i];
              var object = generateMesh(threeJs, d.geometryType, d.geometryProps, d.lineProps, d.width, d.height, d.depth, material, d);
              var rotationOrder = d.rotationOrder;
              if (rotationOrder) {
                object.rotation._order = rotationOrder;
              }
              object.position.x = position.x || 0;
              object.position.y = position.y || 0;
              object.position.z = position.z || 0;
              object.rotation.x = rotation.x || 0;
              object.rotation.y = rotation.y || 0;
              object.rotation.z = rotation.z || 0;
              threeJs.objects.add(object);
              object.userData.dataIndex = i;
            });

            //need to change it to a real preloader for obj
            _context16.next = 9;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 500);
            });
          case 9:
          case "end":
            return _context16.stop();
        }
      }, _callee16);
    }));
    return _addObjectsWithoutAnimation.apply(this, arguments);
  }
  return {
    addObjects: addObjects,
    addObjectsWithoutAnimation: addObjectsWithoutAnimation,
    addToLayers: addToLayers,
    preloader: preloader
  };
}